module.exports = __webpack_public_path__ + "img/ds4.192ee241.png";